// @mui
import { Stack, Typography } from '@mui/material';
// layouts
import LoginLayout from '../../layouts/login';
//
import AuthLoginForm from './AuthLoginForm';

// ----------------------------------------------------------------------

export default function Login() {
  return (
    <LoginLayout>
      <Stack spacing={2} sx={{ mb: 5, alignItems: 'center' }}>
        <Typography variant="h4">Entre com a sua matrícula</Typography>
      </Stack>

      <AuthLoginForm />
    </LoginLayout>
  );
}
